export const DONE_STATES = new Set(["finalizada", "aprovado"]);
export const VIEWS = { pendentes: "A conferir", conferidos: "Conferidos", correcao: "Correções", sem_fechamento: "Sem envio", todos: "Todos" };
export function isPending(row) { return row.closings_count > 0 && !DONE_STATES.has(row.state) && row.state !== "correcao"; }
export function inView(row, view) {
  return view === "todos" || (view === "conferidos" ? DONE_STATES.has(row.state) : view === "correcao" ? row.state === "correcao" : view === "sem_fechamento" ? row.state === "sem_fechamento" : isPending(row));
}
export function counts(rows) {
  return { pendentes: rows.filter(isPending).length, conferidos: rows.filter(d => DONE_STATES.has(d.state)).length,
    correcao: rows.filter(d => d.state === "correcao").length, sem_fechamento: rows.filter(d => d.state === "sem_fechamento").length, todos: rows.length };
}
export function ordered(rows) {
  const priority = { revisar: 0, correcao: 1, em_andamento: 2, pendente: 3, aprovado: 4, finalizada: 4, sem_fechamento: 5 };
  return [...rows].sort((a, b) => (priority[a.state] ?? 9) - (priority[b.state] ?? 9) || a.nome.localeCompare(b.nome, "pt-BR"));
}
export function conferencePath(driver, day, view = "pendentes", search = "") {
  const query = new URLSearchParams({ date: day, view });
  if (driver) query.set("driver", driver);
  if (search) query.set("q", search);
  return `/admin/conferencia?${query}`;
}
export function safeConferenceReturn(value) {
  if (typeof value !== "string" || !value.startsWith("/admin/conferencia?")) return null;
  try { const parsed = new URL(value, "https://internal.invalid"); return parsed.pathname === "/admin/conferencia" ? parsed.pathname + parsed.search : null; }
  catch { return null; }
}
export function closingPath(id, returnTo) {
  return `/admin/fechamentos/${encodeURIComponent(id)}${safeConferenceReturn(returnTo) ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`;
}
export function editClosingPath(id, driver, day, returnTo) {
  const query = new URLSearchParams({ id, driver_id: driver, date: day });
  query.set("returnTo", safeConferenceReturn(returnTo) || conferencePath(driver, day));
  return `/admin/adicionar-fechamento?${query}`;
}
export function draftKey(userId, driver, day) { return `d1-conference-draft:${userId}:${driver}:${day}`; }
export function readDraft(key) {
  try {
    const value = JSON.parse(sessionStorage.getItem(key));
    return value && value.form && Array.isArray(value.form.occurrences) && Number.isInteger(value.version) && typeof value.fingerprint === "string" ? value : null;
  } catch { return null; }
}
export function storeDraft(key, form, base) {
  try { sessionStorage.setItem(key, JSON.stringify({ form, version: base.conference.version || 0, fingerprint: base.fingerprint, closing_revision: base.closing_revision })); } catch { /* O fluxo continua mesmo com armazenamento local indisponível. */ }
}
export function removeDraft(key) { try { sessionStorage.removeItem(key); } catch { /* Sem bloqueio de uso. */ } }
